module.exports = __webpack_public_path__ + "img/tip1.748d5267.png";